<template>
  <v-flex
    xs12
  >
    <OrderDraftItemNote
      :item="item"
      :order="order"
      @note-added="addNote"
    />
    <v-data-table
      v-if="order.hasNotes(item)"
      :items="notes"
      hide-headers
      hide-actions
    >
      <template v-slot:items="props">
        <td class="font-weight-bold">{{ props.item.name }}</td>
        <td>{{ Array.isArray(props.item.values) ? props.item.values.join('; ') : props.item.values }}</td>
        <td class="right">
          <v-btn
            icon
            small
            color="error"
            style="position: relative; right: 15px;"
            @click="removeNote(props.item.name)"
          >
            <v-icon small>delete</v-icon>
          </v-btn>
        </td>
      </template>
    </v-data-table>
  </v-flex>
</template>

<script>
import OrderDraftItemNote from './OrderDraftItemNote'
export default {
  name: 'OrderDraftItemNotes',
  components: {
    OrderDraftItemNote
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    order: {
      type: Object,
      required: true
    }
  },
  computed: {
    notes () {
      if (!this.order.hasNotes(this.item)) {
        return []
      }
      if (Array.isArray(this.item.notes)) {
        return [
          {
            name: 'Notes',
            values: this.item.notes
          }
        ]
      }
      return Object.entries(this.item.notes).map(([key, value]) => {
        return {
          name: key,
          values: value
        }
      })
    }
  },
  methods: {
    addNote () {
      if (this.item.id) {
        this.order.updateItem(this.item.id, { notes: this.item.notes })
      }
    },
    removeNote (byName) {
      try {
        if (byName === 'Notes') {
          this.item.notes = []
          return
        }
        let notes = { ...this.item.notes }
        delete notes[byName]
        this.item.notes = notes
        if (!this.order.hasNotes(this.item)) {
          this.item.notes = []
        }
      } finally {
        if (this.item.id) {
          this.order.updateItem(this.item.id, { notes: this.item.notes })
        }
      }
    }
  }
}
</script>
